import React from "react";
import { Page, StyleSheet, Text } from "@react-pdf/renderer";
import Footer from "../components/Footer";
import Table from "../components/Table";
import Line from "../components/Line";
import { Header } from "../components/Header";
import { DataProps, UnitSystem } from "../../../interfaces/interfaces";
import {
  convertDiameter,
  convertLength,
  convertWeight,
  diameterUnit,
  lengthUnit,
  weightUnit,
} from '../../../utils/unitConversion';

const styles = StyleSheet.create({
  page: {
    padding: 50,
    paddingTop: 40,
  },
  title: {
    fontSize: 15,
    marginBottom: 10,
    textAlign: "center",
    fontFamily: "Times-Roman",
    fontWeight: 600,
    borderBottomColor: "rgb(251,171,53)",
  },
  red: {
    color: "red",
  },
});

export const TableTallyPage = ({
  data: {
    basicInfo,
    tallyDesign,
    mudWeight,
    totalLenght,
    totalWeight,
    showDepths,
  },
  unitSystem = 'imperial' as UnitSystem,
}: {
  data: DataProps;
  unitSystem?: UnitSystem;
}) => {
  const getStatusColor = (status: string) => {
    if (status === "USED") return <Text style={styles.red}>{status}</Text>;
    return status;
  };
  return (
    <Page size="A4" orientation="landscape" style={styles.page}>
      <Header title={basicInfo.client.name} subtitle={basicInfo.well.name} />
      <Text style={styles.title}>Tally Design</Text>
      <React.Fragment>
        <Table>
          <Table.Header>
            <Table.TableHeaderCellMain>Description</Table.TableHeaderCellMain>
            <Table.HeaderCell>Supplier</Table.HeaderCell>
            <Table.HeaderCell>Top Thread Connection</Table.HeaderCell>
            <Table.HeaderCell>Bottom Thread Connection</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>{`Max OD (${diameterUnit(unitSystem)})`}</Table.HeaderCell>
            <Table.HeaderCell>{`Body OD (${diameterUnit(unitSystem)})`}</Table.HeaderCell>
            <Table.HeaderCell>{`Length (${lengthUnit(unitSystem)})`}</Table.HeaderCell>
            <Table.HeaderCell>{`Top (${lengthUnit(unitSystem)}) MD`}</Table.HeaderCell>
            <Table.HeaderCell>{`Bottom (${lengthUnit(unitSystem)}) MD`}</Table.HeaderCell>
            <Table.HeaderCell>{`Weight (${weightUnit(unitSystem)})`}</Table.HeaderCell>
          </Table.Header>
          <Table.Body>
            <>
              {tallyDesign.map((item) => (
                <React.Fragment key={item.id}>
                  {item.id !== 0 && (
                    <Table.Row>
                      <Table.CellMain>
                        {item.name || item.description}{" "}
                        {item.tailJoint && `QTY ${item.quantity}`}
                      </Table.CellMain>
                      <Table.Cell>{item.supplier || "-"}</Table.Cell>
                      <Table.Cell>{item.topThreadConnection || "-"}</Table.Cell>
                      <Table.Cell>
                        {item.bottomThreadConnection || "-"}
                      </Table.Cell>
                      <Table.Cell>
                        {item?.status?.name
                          ? getStatusColor(item?.status?.name)
                          : "-"}
                      </Table.Cell>
                      <Table.Cell>{item.maxOD ? convertDiameter(item.maxOD, unitSystem) : "-"}</Table.Cell>
                      <Table.Cell>{item.bodyOD ? convertDiameter(item.bodyOD, unitSystem) : "-"}</Table.Cell>
                      <Table.Cell>
                        {item.length && item.quantity
                          ? convertLength(item.length * item.quantity, unitSystem)
                          : item.length
                          ? convertLength(item.length, unitSystem)
                          : "-"}
                      </Table.Cell>
                      <Table.Cell>{showDepths && item.top != null ? convertLength(item.top, unitSystem) : "-"}</Table.Cell>
                      <Table.Cell>{showDepths && item.bottom != null ? convertLength(item.bottom, unitSystem) : "-"}</Table.Cell>
                      <Table.Cell>
                        {item.quantity && item.weight
                          ? convertWeight(item.weight * item.quantity, unitSystem)
                          : item.weight
                          ? convertWeight(item.weight, unitSystem)
                          : "-"}
                      </Table.Cell>
                    </Table.Row>
                  )}
                </React.Fragment>
              ))}
              <Table.Row>
                <Table.Cell>
                  Total Weight of Mud Joints full with sand
                </Table.Cell>
                <Table.Cell>{mudWeight != null ? convertWeight(mudWeight, unitSystem) : "-"}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Total Length</Table.Cell>
                <Table.Cell>{totalLenght != null ? convertLength(totalLenght, unitSystem) : "-"}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Total Weight</Table.Cell>
                <Table.Cell>{totalWeight != null ? convertWeight(totalWeight, unitSystem) : "-"}</Table.Cell>
              </Table.Row>
            </>
          </Table.Body>
        </Table>
        <Line color="yellow" />
      </React.Fragment>
      <Footer />
    </Page>
  );
};
